// NoPermission.js
const NoPermission = () => {
    return( 
        <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '88vh',
                fontWeight: '700',
            }}>
            You do not have permission to view this page. Please contact the Admin.
        </div>
    )
};

export default NoPermission;
